import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import {
  selectEventInfosListOptions,
  setListOptions,
  selectEventInfosListStructure,
} from '@/features/domain/lists'
import { useAppDispatch } from '@/store'

export function useSorter() {
  const listOptions = useSelector(selectEventInfosListOptions)
  const structure = useSelector(selectEventInfosListStructure)
  const editing = false
  const dispatch = useAppDispatch()

  const [field, setField] = useState(() => listOptions.sort[0].field)
  const [direction, setDirection] = useState(() => listOptions.sort[0].direction)

  useEffect(() => {
    if (!listOptions.sort) return
    if (listOptions.sort[0].field === field && listOptions.sort[0].direction === direction) return

    dispatch(
      setListOptions({
        category: 'eventInfos',
        options: {
          ...listOptions,
          sort: [
            {
              field,
              direction,
            },
          ],
        },
      }),
    )
  }, [dispatch, field, direction, listOptions])

  return {
    editing,
    field,
    setField,
    direction,
    setDirection,
    noEntries: structure.totalItems === 0,
  }
}
